import { rankWith, type ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { CaseFieldRow } from '../../shared/renderers/CaseReviewRenderers';
import { useMeddraCoding } from '../hooks/useMeddraCoding';
import { MeddraCodingPanel } from '../components/MeddraCodingPanel';
import { CODING_RENDERER } from '@/features/meddra/shared/model/meddraCoding';
function CodingControl(props: ControlProps) {
  const coding = useMeddraCoding(props);
  return <CaseFieldRow props={props} field={coding.field}>{editable => <MeddraCodingPanel coding={{ ...coding, editable: editable && coding.editable }} />}</CaseFieldRow>;
}
export const meddraCodingRenderer = withJsonFormsControlProps(CodingControl);
export const meddraCodingTester = rankWith(12, schema =>
  (schema as { options?: { renderer?: string } }).options?.renderer === CODING_RENDERER);
